"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var repaymentAmountStyles_1 = require("./repaymentAmountStyles");
var ClickableCustomTooltip_1 = require("../../common/ClickableCustomTooltip/ClickableCustomTooltip");
var Close_1 = require("@material-ui/icons/Close");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var RepaymentAmount = function (_a) {
    var percentageValue = _a.percentageValue, disclaimer = _a.disclaimer;
    var styles = repaymentAmountStyles_1.default();
    return (<core_1.Box>
      <core_1.Box className={styles.repaymentAmountContainer}>
        <core_1.Typography variant="caption" className={styles.label} data-test={'text:price:repayment:label'}>
          {percentageValue}
        </core_1.Typography>
        <Translation_1.default className={styles.label} id="trans__fincalc__payment_section_payment_details__pa_label"/>
        <ClickableCustomTooltip_1.default translationId="trans__checkout__vehicle_details__price_with_finance__indicative_comparison_rate" tooltipType={'repayment-open'}>
          <>
            <Close_1.default className={styles.tooltipCloseIcon} data-test="common:mui:tooltip:repayment-close-button"/>
            <core_1.Typography className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: disclaimer }} data-test="text:repayment:disclaimer"/>
          </>
        </ClickableCustomTooltip_1.default>
      </core_1.Box>
      <core_1.Box>
        <core_1.Typography variant="caption" className={styles.subLabel} data-test={'text:price:comparison:label'}>
          <Translation_1.default id="trans__checkout__vehicle_details__price_with_finance__comparison_rate_label"/>
        </core_1.Typography>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = RepaymentAmount;
